import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import Vendors from './vendors'
import Projects from './projects'
import Departments from './departments'
import GlAccounts from './glAccounts'
import GlAccountTypes from './glAccountTypes'
import WTaxCodes from './wTaxCodes'
import WTaxRates from './wTaxRates'
import ItemNo from './itemNo'

function TabPanel (props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

function a11yProps (index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  }
}
const tabs = [
  'Vendors',
  'Projects',
  'Departments',
  'GL Accounts',
  'GL Account Types',
  'W Tax Codes',
  'W Tax Rates',
  'Item No'
]

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}))

export default function VerticalTabs () {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <div className={classes.root}>
      <div style={{ position: 'fixed', height: '100%', zIndex: '1000' }}>
        <Tabs
          style={{ height: '100%', backgroundColor: 'white' }}
          orientation='vertical'
          variant='scrollable'
          value={value}
          onChange={handleChange}
          aria-label='Vertical tabs example'
          className={classes.tabs}
        >
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab} {...a11yProps(index)}></Tab>
          ))}
        </Tabs>
      </div>
      <div style={{ marginLeft: '200px' }}>
        <TabPanel value={value} index={0}>
          <Vendors />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Projects />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Departments />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <GlAccounts />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <GlAccountTypes />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <WTaxCodes />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <WTaxRates />
        </TabPanel>
        <TabPanel value={value} index={7}>
          <ItemNo />
        </TabPanel>
      </div>
    </div>
  )
}
